<template>
  <!-- Salide de cards  1-->
  <div class="col-12 contenidoSlider mt-4" v-if="banSettingsTA">
    <div v-show="false">{{titleHotelCards}}</div>
    <div class="cards cardsSlider" v-for="(hotel, k1) in hotelesServices.hotelBrand" :key="'_hotel' + k1">
      <p class="superTitle" v-if="banHotelCards">{{hotel.brandName}}</p>
      <agile class="" v-if="banHotelCards">
        <div class="slide" v-for="(slider, k2) in hotel.hotel" :key="'_slider' + k2">

          <div class="col-4 mb-3 mb-lg-0" v-for="(franquicia, k3) in slider.franquicias" :key="'_franquicia' + k3">
            <div id="show-btn" @click="mostrarInformacionPosicion(k1, k2, k3)" class="card tarjetas" >
              <img class="fix-ie card-img-top" :src="franquicia.hotelImageHome" alt="Card image cap">
              <div class="card-body">
                <p class="card-title"><b>{{franquicia.hotelName}}</b></p>
                <p class="card-text descripcionElipse">{{franquicia.hotelDescription}}</p>
              </div>
              <div class="card-body card-icon d-flex justify-content-between ie-fix icons">
                <img class="amenidad-icon-size-18" width="18" height="18" v-for="(amenidad, k) in franquicia.hotelAmenities" :key="'amenidad' + k" :src="amenidad.amenityIcon" v-b-popover.hover.top="{ content: amenidad.amenityName, customClass:'PC-popover' }">
              </div>
            </div>
          </div>

        </div>

        <template slot="prevButton"><i class="demo-icon icon-navigate-left" :class="sliderRow1 ? 'gris' : ''" @click="sliderRow1 = !sliderRow1"></i></template>
        <template slot="nextButton"><i class="demo-icon icon-right" :class="sliderRow1 ? '' : 'gris'" @click="sliderRow1 = !sliderRow1"></i></template>
      </agile>
    </div>
      <Loader v-if="!banHotelCards" />

    <!--  Espacio para no slider -->
    <div class="cards cardsSliderMovil" v-for="(hotelitos, k11) in hotelesServices.hotelBrand" :key="'_hotelitos' + k11">
      <p class="superTitle mt-3 px-3">{{hotelitos.brandName}}</p>
      <div class="d-flex d-lg-none justify-content-start carruselMinium px-3">
        <div class="col-11 col-sm-8 col-md-7" v-for="(franquicia1, k22) in hotelitos.hotel[0].franquicias" :key="'_franquicia1' + k22">
          <div class="card tarjetasMovil" @click="mostrarInformacionPosicion(k11, 0, k22)">
            <img class="card-img-top" :src="franquicia1.hotelImageHome" alt="Card image cap">
            <div class="card-body">
              <p class="card-title"><b>{{franquicia1.hotelName}}</b></p>
              <p class="card-text descripcionElipse">{{franquicia1.hotelDescription}}</p>
              <div class="card-body card-icon d-flex justify-content-between">
                <img class="amenidad-icon-size-18" v-for="(amenidad1, kk) in franquicia1.hotelAmenities" :key="'_amenidad1' + kk" :src="amenidad1.amenityIcon" v-b-popover.hover.top="{ content: amenidad1.amenityName, customClass:'PC-popover' }">
              </div>
            </div>
          </div>
        </div>

        <div class="col-11 col-sm-8 col-md-7" v-for="(franquicia2, k33) in hotelitos.hotel[1].franquicias" :key="'_franquicia2' + k33">
          <div class="card tarjetasMovil" @click="mostrarInformacionPosicion(k11, 1, k33)">
            <img class="card-img-top" :src="franquicia2.hotelImageHome" alt="Card image cap">
            <div class="card-body">
              <p class="card-title"><b>{{franquicia2.hotelName}}</b></p>
              <p class="card-text descripcionElipse">{{franquicia2.hotelDescription}}</p>
              <div class="card-body card-icon d-flex justify-content-between">
                <img class="amenidad-icon-size-18" v-for="(amenidad2, kkk) in franquicia2.hotelAmenities" :key="'_amenidad2' + kkk" :src="amenidad2.amenityIcon" v-b-popover.hover.top="{ content: amenidad2.amenityName, customClass:'PC-popover' }">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Modal -->
    <b-modal id="modalReservaciones" content-class="modalReservaciones" size="lg" hide-footer v-if="banModal">
      <template slot="modal-title">
        <lingallery :iid.sync="currentId" :items="listMiniHotel"/>
      </template>
      <template slot="modal-header-close">
        <b-button class="mt-3 closeModal" variant="outline-warning" block @click="$bvModal.hide('modalReservaciones'), closeModal">
          <i class="icon-close"></i>
        </b-button>
      </template>
      <div class="d-block">
        <p class="title">{{ hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].hotelName }}</p>
        <p>{{ hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].hotelDescription }} </p>
      </div>

      <div class="d-block">
        <div v-b-toggle="'comodidades'" class="row acordion" @click="[comodidades = !comodidades]">
          <div class="col-10 mb-1">
            <p>
              <b>{{ $t('language.posadasCorporate.hotelCards.hotelServices') }}</b>
            </p>
          </div>
          <div class="naviagate col-2 text-center">
            <i class="navi icon-navigate-down" :class="[comodidades ? '' : 'oculto']"></i>
            <i class="navi icon-up" :class="[comodidades ? 'oculto' : '']"></i>
          </div>
        </div>
        <b-collapse visible id="comodidades">
          <ul class="listIconModal row">
            <div class="col-12 col-lg-6">
              <li class="flex m-b-5" v-for="(hAmenidades, kh, ih) in listAmenities1" :key="kh + '_' + ih">
                <img class="amenidad-icon-size-18 amenidad-modal" :src="hAmenidades.amenityIcon">
                <p class="m-b-0">{{ hAmenidades.amenityName }}</p>
              </li>
            </div>

            <div class="col-12 col-lg-6" v-if="(listAmenities2.length > 0?true:false)">
              <li class="flex m-b-5" v-for="(hAmenidades, kh, ih) in listAmenities2" :key="kh + '_' + ih">
                <img class="amenidad-icon-size-18 amenidad-modal" :src="hAmenidades.amenityIcon">
                <p class="m-b-0">{{ hAmenidades.amenityName }}</p>
              </li>
            </div>
          </ul>
        </b-collapse>
      </div>

      <div class="d-block">
        <div v-b-toggle="'ubicacion'" class="row acordion" @click="[ubicacion = !ubicacion]">
          <div class="col-10 mb-1">
            <p><b>{{ $t('language.posadasCorporate.hotelCards.location') }}</b></p>
          </div>
          <div class="naviagate col-2 text-center">
            <i class="navi icon-navigate-down" :class="[ubicacion ? '' : 'oculto']" ></i>
            <i class="navi icon-up" :class="[ubicacion ? 'oculto' : '']"></i>
          </div>
        </div>
        <b-collapse visible id="ubicacion">
          <ul class="listIconModal row">
            <div class="col-12 col-lg-6">
              <li class="d-inline-flex d-lg-flex" v-if="(hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].phone?true:false)">
                <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/ic_tel.svg">
                <p class="m-b-0">{{ hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].phone }}&nbsp;</p>
              </li>
              <li class="d-inline-flex d-lg-flex m-b-5" v-if="(hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].fax?true:false)">
                <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/ic_tel.svg">
                <p class="m-b-0">{{ hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].fax }}</p>
              </li>
              <li class="flex align-flex-start">
                <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/location.svg">
                <p class="m-b-0">{{hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].address}}<br></p>
              </li><br>
              <li class="row">
                <div class="col-1"></div>
                <p class="col-9 mb-1 subtitle azulBase cursor" @click="redirectMaps">{{ $t('language.posadasCorporate.hotelCards.seeMaps') }}
                  <i class="demo-icon icon-arrow-right subtitle azulBase"></i>
                </p>
              </li>
            </div>
            <div class="col-12 col-lg-6">
              <iframe
                width="100%"
                height="100%"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                :src="srcMaps"
              >
              </iframe>
            </div>
          </ul>
        </b-collapse>
      </div>

      <div class="d-block">
        <div v-b-toggle="'horarios'" class="row acordion" @click="[horarios = !horarios]">
          <div class="col-10 mb-1">
            <p><b>{{ $t('language.posadasCorporate.hotelCards.schedule') }}</b></p>
          </div>
          <div class="naviagate col-2 text-center">
            <i class="navi icon-navigate-down" :class="[horarios ? '' : 'oculto']" ></i>
            <i class="navi icon-up" :class="[horarios ? 'oculto' : '']"></i>
          </div>
        </div>
        <b-collapse visible id="horarios">
          <ul class="listIconModal row">
            <div class="col-6">
              <li class="flex">
                <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/check-in.svg">
                <p class="m-b-0">{{ $t('language.posadasCorporate.hotelCards.in') }}: {{ hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].checkIn }}</p></li>
            </div>
            <div class="col-6">
              <li class="flex">
                <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/check-out.svg">
                <p class="m-b-0">{{ $t('language.posadasCorporate.hotelCards.out') }}: {{hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].hotelCode == 'EXC' ? '11:00' : hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].checkOut}}</p>
              </li>
            </div>
          </ul>
        </b-collapse>
      </div>

      <div class="d-block pt-4">
        <div class="row d-flex justify-content-end">
          <div class="col-12 col-lg-6 order-2 order-lg-1">
            <b-button class="mt-3 secondary-button btnModal " variant="outline" block @click="$bvModal.hide('modalReservaciones')">{{ $t('language.posadasCorporate.hotelCards.close') }}</b-button>
          </div>
          <div class="col-12 col-lg-6 order-1 order-lg-2 mb-3 mb-lg-0">
            <b-button :disabled="isGroup()" class="mt-3 button btnModal" variant="outline" block @click="salut(hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].hotelName, hotelesServices.hotelBrand[position.k1].hotel[position.k2].franquicias[position.k3].hotelCode)">{{ $t('language.posadasCorporate.hotelCards.reserve') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

 <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>


      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->


  </div>

</template>

<script>
  import * as GlobalServices from "../../utils/GlobalServices";
  import * as GlobalFunctions from "../../utils/GlobalFunctions";
  import { VueAgile } from '../../customComponents/vue-agile';
  import Lingallery from 'lingallery';
  import SecureLS from 'secure-ls';
  import i18n from '../../plugins/i18n';
  import Loader from '../loader/Loader';
  import Modal from '../addons/Modal.vue'


export default {
  components: {
    agile: VueAgile,
    Lingallery,
    Loader,
    Modal
  },
  name: 'HotelCards',
  data: () =>{
    return {
      banSettingsTA: false,
      InfoGrupo: "",
      groupBool: false,
      banHotelCards: false,
isExpiredModalVisible: false,
      contHotelCards: 0,
      ls: new SecureLS({ encodingType: "aes" }),
      hotelesServices: {},
      position: {
        k1: null,
        k2: null,
        k3: null
      },
      listAmenities1: [],
      listAmenities2: [],
      listMiniHotel: [],
      banModal: false,
      srcMaps: '',
      currentId: null,

      card: null,
      asNavFor1: [],
      comodidades: false,
      ubicacion: false,
      horarios: false,
      asNavFor2: [],
      sliderRow1: true,
      sliderRow2: true,
      sliderRow3: true,
      sliderRow4: true,
      sliderRow5: true,
      sliderRow6: true,
			options1: {
				dots: false,
				fade: true,
				navButtons: false
			},
			options2: {
				autoplay: true,
				centerMode: true,
				dots: false,
				navButtons: false,
				slidesToShow: 3,
				responsive: [
          {
            breakpoint: 600,
            settings: {
                slidesToShow: 5
            }
          },
          {
            breakpoint: 1000,
            settings: {
                navButtons: true
            }
          }
        ]
      },
    }
  },
  methods: {
    isGroup(){
      var ls = new SecureLS({encodingType: 'aes'});
        var grupoInfoLs = ls.get('InfoGrupo')
        this.InfoGrupo = grupoInfoLs.data
      if(this.InfoGrupo === undefined){
        this.groupBool = false;
        return this.groupBool;
      }
      else{
        this.groupBool = true;
        return this.groupBool;
      }
      
    },
    closeExpiredModal() {
  this.isExpiredModalVisible = false
             var ls = new SecureLS({encodingType: 'aes'});
             GlobalFunctions.localStorageClean();
                this.$router.push({ name: "Login" });
    },
    salut(hotelName, hotelCode) {
      this.$bvModal.hide('modalReservaciones')
      this.$store.commit('hotelName', {hotelName: hotelName , hotelCode: hotelCode} )
    },
    sesionClose(){
              this.isExpiredModalVisible = true

    },
    consultaHoteles(lugar){

      if (this.contHotelCards === 0) {
        this.contHotelCards ++;
      } else {
          this.banHotelCards = false;
      }

      setTimeout(() => {
        if (this.ls.get('HotelCard') === '') {

          GlobalServices._consultaHoteles('token', this.ls.get('Language').data).then(response => {
            this.ls.set('HotelCard', response);
            this.banHotelCards = true;
            this.hotelesServices = this.ls.get('HotelCard');
          }).catch(error => {
          });
        } else {
          if (this.ls.get('HotelCard') !== '' && lugar === 1) {
            GlobalServices._consultaHoteles('token', this.ls.get('Language').data).then(response => {
              this.ls.set('HotelCard', response);
              this.banHotelCards = true;
              this.hotelesServices = this.ls.get('HotelCard');
            }).catch(error => {
            });
          } else{
            this.banHotelCards = true;
            this.hotelesServices = this.ls.get('HotelCard');
          }
        }
      }, 1);
    },
    mostrarInformacionPosicion(k1, k2, k3){
      this.listAmenities1 = [];
      this.listAmenities2 = [];
      this.listMiniHotel = [];
      this.position.k1 = k1;
      this.position.k2 = k2;
      this.position.k3 = k3;
      this.banModal = true;
      for (let [i, miniHotel] of this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].hotelDetailImageList.entries()) {
        this.listMiniHotel.push(
            {id:'someid' + i, src: miniHotel.hotelImageDetail, thumbnail: miniHotel.hotelImageDetail, alt: 'Some alt text'},
        );
      }

      var contAmenities = this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].hotelAmenities.length;
      if (contAmenities <= 6) {
        this.listAmenities1 = this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].hotelAmenities;
      } else {
        for (let i = 0; i < this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].hotelAmenities.length; i++) {
          if (i <= 5) {
            this.listAmenities1.push(this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].hotelAmenities[i]);
          } else {
            this.listAmenities2.push(this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].hotelAmenities[i]);
          }
        }
      }

      this.srcMaps = process.env.VUE_APP_APIMAPS + this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].latitude + ',' + this.hotelesServices.hotelBrand[k1].hotel[k2].franquicias[k3].longitude + '&hl=es;z=14&output=embed'
      setTimeout(() => {
        this.$bvModal.show('modalReservaciones');
      }, 1);
    },
    closeModal(){
      this.banModal = true;
    },
    redirectMaps(){
      window.open(this.srcMaps.replace('embed','iframe'), '_blank');
    }
  },
  beforeMount(){
    this.consultaHoteles(0);
  },
  computed: {
    titleHotelCards(){
      this.consultaHoteles(1);
      return i18n.t('language.posadasCorporate.hotelCards.hotelCards');
    },
    getGroupInfo(){
        var groupInfo = {
          hotelCode: this.$store.getters.gettingGroupHotelCode,
          groupCode: this.$store.getters.gettingGroupCode,
          currencyCode: this.$store.getters.gettingCurrency,
          checkIn: this.$store.getters.gettingCheckIn,
          checkOut:  this.$store.getters.gettingCheckOut,
          roomCodes:  this.$store.getters.gettingRoomCodes
        }
        return groupInfo
      },
  },
    created(){
//START KB58887 - configuraciones user TA  
    var ls = new SecureLS({ encodingType: "aes" });
    var readingProfile = ls.get("Profile");
        
    var ProfileType = "";
    if(readingProfile){
      ProfileType = readingProfile.data.profileType;
    }

    if(ProfileType == 'TA'){
          GlobalServices._searchConfigTA(this.ls.get("Token").data).then(response => {
            if (response.status == 200) {
                response.data.response.forEach(item => {
                    var test=item.title;
                    if(test == "GRID" && item.flag== "TRUE"){
                        console.log("componente bloqueado video");
                        this.banSettingsTA = true;
                      }
                    });
                  }
            })
            .catch(error => {
              console.log("error: "+error)
            });  
            }else{
              this.banSettingsTA = true;
              }
   //END KB58887
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" scope>
  // @import '../assets/scss/integration/style.scss';
  // Temporal en lo que tenemos logo
  @import '../../assets/scss/config.scss';
  .tarjetas {
    cursor: pointer;
    min-height: 400px;
  }
  // estilos para edge
  @supports (-ms-ime-align:auto) {
    @media (min-width: 886px) {
      .tarjetas {
        max-width: 325px;
      }
    }
    @media only screen and (max-width: 1440px) {
      .tarjetas {
        max-width: 325px;
      }
    }
    @media only screen and (max-width: 1100px) {
      .tarjetas {
        max-width: 400px;
      }
    }
    // Muestra iconos
    .ie-fix.icons{
      min-height: 48.88px;
    }
    // Controla altura de imagenes
    .fix-ie.card-img-top{
      max-height: 188px;
    }
  }
  // estilos para IE
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    // Muestra iconos
    .ie-fix.icons{
      min-height: 48.88px;
    }
    // Controla altura de imagenes
    .fix-ie.card-img-top{
      max-height: 188px;
    }
  }
  .cardsSliderMovil {
      display: none;
    }
  .card {
    color: $grayShadeDark;
    border-radius: 4px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    border: solid 1px #f6f6f6;
    margin: 2px 0;
    ul {
      list-style: none;
    }
  }
  .card-body {
    padding: 16px 8px;
  }
  .card-title {
    min-height: 42px;
  }
  .card-text {
    height: auto;
    overflow: hidden;
  }
  .card-icon {
    padding: 0px 8px 24px 8px;
    .demo-icon {
      font-size: $font-size-exlarge;
      color: $colorBase3;
    }
  }
  .agile__actions {
    margin-top: 20px;
    button {
      display: none !important;
    }
  }
  .agile__nav-button {
    display: none !important;
  }
  .agile__nav-button {
    display: none !important;
  }
  .agile__nav-button:hover {
    color: #888;
  }
  .agile__dot button {
    background-color: #eee;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: block;
    height: 10px;
    font-size: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
    transition-duration: 0.3s;
    width: 10px;
  }
  .agile__dot--current button, .agile__dot:hover button {
    background-color: #888;
  }
  .gris {
    color: #c9c9c9;
  }
  .carruselMinium {
    overflow: scroll;
    height: auto;
  }
  .top {
    margin: 0 auto;
    display: table;
  }

  @media only screen and (max-width: 1440px) {
    .tarjetas {
      cursor: pointer;
      max-width: 325px;
    }
  }
  @media only screen and (max-width: 1100px) {
    .tarjetas {
      cursor: pointer;
      max-width: 325px;
    }
  }
  @media only screen and (max-width: 992px) {

    .cardsSlider {
      display: none;
    }
    .cardsSliderMovil {
      display: initial;
    }
    .superTitle {
      min-height: 40px;
    }
    .contenidoSlider {
      padding: 0px;
    }
  }
  .contenidoSlider {
    margin-bottom: 32px;
  }
  </style>
